import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api';

const PAGE_SIZE = 50;

export default function BuchungenPage() {
  const [searchParams] = useSearchParams();
  const [buchungen, setBuchungen] = useState([]);
  const [kategorien, setKategorien] = useState([]);
  const [filter, setFilter] = useState({
    kategorie: searchParams.get('kategorie') || '',
    nur_unbestaetigt: false
  });
  const [search, setSearch] = useState(searchParams.get('q') || '');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [reanalyseMsg, setReanalyseMsg] = useState('');
  const [aufgeklappt, setAufgeklappt] = useState({});

  useEffect(() => { api.get('/kategorien').then(r => setKategorien(r.data)); }, []);
  useEffect(() => { laden(); }, [filter, search, page]);

  async function laden() {
    const params = { limit: PAGE_SIZE, offset: (page - 1) * PAGE_SIZE };
    if (filter.kategorie) params.kategorie = filter.kategorie;
    if (filter.nur_unbestaetigt) params.nur_unbestaetigt = '1';
    if (search) params.q = search;
    const r = await api.get('/buchungen', { params });
    setBuchungen(r.data.buchungen);
    setTotal(r.data.total);
  }

  function setFilterAndReset(newFilter) { setFilter(newFilter); setPage(1); }
  function setSearchAndReset(val) { setSearch(val); setPage(1); }

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  async function kategorieAendern(id, kat) {
    await api.put('/buchungen/' + id + '/kategorie', { kategorie: kat, lerne_regel: true });
    laden();
  }

  async function flagsAendern(id, flags) {
    await api.put('/buchungen/' + id + '/flags', flags);
    setBuchungen(prev => prev.map(b => b.id === id ? { ...b, ...flags } : b));
  }

  async function alleBestaetigen() {
    await api.post('/buchungen/alle-bestaetigen');
    laden();
  }

  async function reanalyse() {
    setReanalyseMsg('⏳ Analysiere...');
    const r = await api.post('/reanalyse');
    setReanalyseMsg('✅ ' + r.data.aktualisiert + ' Buchungen aktualisiert');
    setTimeout(() => setReanalyseMsg(''), 4000);
    laden();
  }

  const unbestaetigt = buchungen.filter(b => !b.ki_bestaetigt && b.ki_kategorie).length;

  function toggleAufklappen(id) {
    setAufgeklappt(prev => ({ ...prev, [id]: !prev[id] }));
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h1 style={{ margin: 0, fontSize: '20px', color: '#1e293b' }}>📋 Buchungen ({total})</h1>
        <button onClick={reanalyse}
          style={{ background: '#6366f1', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
          🔄 Re-Analyse
        </button>
      </div>

      {reanalyseMsg && (
        <div style={{ background: '#eff6ff', borderRadius: '10px', padding: '10px 14px', marginBottom: '12px', color: '#3b82f6', fontWeight: '600' }}>
          {reanalyseMsg}
        </div>
      )}

      {unbestaetigt > 0 && (
        <div style={{ background: '#fef3c7', borderRadius: '12px', padding: '10px 14px', marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #f59e0b' }}>
          <span style={{ color: '#92400e', fontWeight: '600', fontSize: '13px' }}>🤖 {unbestaetigt} KI-Vorschläge</span>
          <button onClick={alleBestaetigen}
            style={{ background: '#f59e0b', color: 'white', border: 'none', borderRadius: '8px', padding: '5px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>
            Alle ✓
          </button>
        </div>
      )}

      <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
        <input placeholder="🔍 Empfänger / Verwendungszweck..." value={search}
          onChange={e => setSearchAndReset(e.target.value)}
          style={{ flex: 1, padding: '9px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '12px' }} />
      </div>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
        <select value={filter.kategorie} onChange={e => setFilterAndReset({...filter, kategorie: e.target.value})}
          style={{ flex: 1, padding: '9px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '12px' }}>
          <option value="">Alle Kategorien</option>
          {kategorien.map(k => <option key={k.name} value={k.name}>{k.icon} {k.name}</option>)}
        </select>
        <button onClick={() => setFilterAndReset({...filter, nur_unbestaetigt: !filter.nur_unbestaetigt})}
          style={{ padding: '9px 12px', borderRadius: '8px', border: '2px solid ' + (filter.nur_unbestaetigt ? '#6366f1' : '#e2e8f0'),
            background: filter.nur_unbestaetigt ? '#eff6ff' : 'white', cursor: 'pointer', fontSize: '11px', fontWeight: '600',
            color: filter.nur_unbestaetigt ? '#6366f1' : '#64748b' }}>
          🤖 KI
        </button>
      </div>

      {total > PAGE_SIZE && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px',
          background: 'white', borderRadius: '10px', padding: '8px 12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <button disabled={page === 1} onClick={() => setPage(p => p - 1)}
            style={{ border: '1px solid #e2e8f0', borderRadius: '6px', padding: '5px 10px', cursor: page === 1 ? 'not-allowed' : 'pointer',
              background: page === 1 ? '#f8fafc' : 'white', color: page === 1 ? '#cbd5e1' : '#374151', fontWeight: '600' }}>
            ‹ Zurück
          </button>
          <span style={{ fontSize: '12px', color: '#64748b' }}>Seite {page} / {totalPages} · {total} Buchungen</span>
          <button disabled={page === totalPages} onClick={() => setPage(p => p + 1)}
            style={{ border: '1px solid #e2e8f0', borderRadius: '6px', padding: '5px 10px', cursor: page === totalPages ? 'not-allowed' : 'pointer',
              background: page === totalPages ? '#f8fafc' : 'white', color: page === totalPages ? '#cbd5e1' : '#374151', fontWeight: '600' }}>
            Weiter ›
          </button>
        </div>
      )}

      {buchungen.map(b => (
        <div key={b.id} style={{ background: 'white', borderRadius: '12px', padding: '12px', marginBottom: '8px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
          borderLeft: '3px solid ' + (b.muss_kuendigen ? '#ef4444' : b.ist_geldfresser ? '#f59e0b' : b.ist_ueberfluessig ? '#8b5cf6' : b.ki_bestaetigt === 0 && b.ki_kategorie ? '#f59e0b' : '#e2e8f0') }}>

          {/* Hauptzeile */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
            onClick={() => toggleAufklappen(b.id)}>
            <div style={{ flex: 1, cursor: 'pointer' }}>
              <div style={{ fontWeight: '600', fontSize: '13px', color: '#1e293b' }}>{b.empfaenger || b.verwendungszweck}</div>
              <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>{b.datum} · {b.bank}</div>
              {/* Flag-Badges */}
              <div style={{ display: 'flex', gap: '4px', marginTop: '4px', flexWrap: 'wrap' }}>
                {b.ist_geldfresser ? <span style={{ background: '#fef3c7', color: '#d97706', fontSize: '10px', padding: '2px 6px', borderRadius: '4px', fontWeight: '700' }}>🔥 Geldfresser</span> : null}
                {b.ist_ueberfluessig ? <span style={{ background: '#f3e8ff', color: '#7c3aed', fontSize: '10px', padding: '2px 6px', borderRadius: '4px', fontWeight: '700' }}>🗑️ Überflüssig</span> : null}
                {b.muss_kuendigen ? <span style={{ background: '#fee2e2', color: '#dc2626', fontSize: '10px', padding: '2px 6px', borderRadius: '4px', fontWeight: '700' }}>✂️ Kündigen!</span> : null}
              </div>
            </div>
            <div style={{ textAlign: 'right', marginLeft: '8px' }}>
              <div style={{ fontWeight: '700', fontSize: '15px', color: b.betrag >= 0 ? '#10b981' : '#ef4444' }}>
                {b.betrag >= 0 ? '+' : ''}{b.betrag.toFixed(2)} €
              </div>
              <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>
                {aufgeklappt[b.id] ? '▲' : '▼'}
              </div>
            </div>
          </div>

          {/* Aufgeklappter Bereich */}
          {aufgeklappt[b.id] && (
            <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #f1f5f9' }}>
              {/* Kategorie */}
              <div style={{ marginBottom: '8px' }}>
                <label style={{ fontSize: '11px', color: '#64748b', fontWeight: '600' }}>Kategorie</label>
                <div style={{ display: 'flex', gap: '6px', marginTop: '4px' }}>
                  <select value={b.kategorie || ''} onChange={e => kategorieAendern(b.id, e.target.value)}
                    style={{ flex: 1, padding: '7px', borderRadius: '6px', border: '1px solid #e2e8f0', fontSize: '12px' }}>
                    {kategorien.map(k => <option key={k.name} value={k.name}>{k.icon} {k.name}</option>)}
                  </select>
                  {b.ki_bestaetigt === 0 && b.ki_kategorie && (
                    <button onClick={() => kategorieAendern(b.id, b.ki_kategorie)}
                      style={{ background: '#6366f1', color: 'white', border: 'none', borderRadius: '6px', padding: '7px 10px', cursor: 'pointer', fontSize: '11px', fontWeight: '700' }}>
                      ✓ KI
                    </button>
                  )}
                </div>
              </div>

              {/* 3 Flag-Buttons */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '6px', marginBottom: '8px' }}>
                {[
                  ['ist_geldfresser', '🔥', 'Geldfresser', '#fef3c7', '#d97706', '#fffbeb'],
                  ['ist_ueberfluessig', '🗑️', 'Überflüssig', '#f3e8ff', '#7c3aed', '#faf5ff'],
                  ['muss_kuendigen', '✂️', 'Kündigen', '#fee2e2', '#dc2626', '#fff5f5'],
                ].map(([field, icon, label, bgAktiv, colorAktiv, bgInaktiv]) => (
                  <button key={field}
                    onClick={() => flagsAendern(b.id, {
                      ist_geldfresser: field === 'ist_geldfresser' ? (b.ist_geldfresser ? 0 : 1) : b.ist_geldfresser,
                      ist_ueberfluessig: field === 'ist_ueberfluessig' ? (b.ist_ueberfluessig ? 0 : 1) : b.ist_ueberfluessig,
                      muss_kuendigen: field === 'muss_kuendigen' ? (b.muss_kuendigen ? 0 : 1) : b.muss_kuendigen,
                    })}
                    style={{
                      padding: '8px 4px', border: '1px solid ' + (b[field] ? colorAktiv : '#e2e8f0'),
                      borderRadius: '8px', cursor: 'pointer', fontSize: '11px', fontWeight: '700',
                      background: b[field] ? bgAktiv : 'white', color: b[field] ? colorAktiv : '#94a3b8',
                      textAlign: 'center'
                    }}>
                    {icon}<br/>{label}
                  </button>
                ))}
              </div>

              {/* Notiz */}
              <input placeholder="Notiz..." defaultValue={b.user_notiz || ''}
                onBlur={e => flagsAendern(b.id, {
                  ist_geldfresser: b.ist_geldfresser, ist_ueberfluessig: b.ist_ueberfluessig,
                  muss_kuendigen: b.muss_kuendigen, user_notiz: e.target.value
                })}
                style={{ width: '100%', padding: '7px', borderRadius: '6px', border: '1px solid #e2e8f0', fontSize: '12px', boxSizing: 'border-box' }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
